import "./OurProducts.css";

// IMPORT ALL 23 PRODUCT IMAGES
import Product1 from "../../Products/Product1.webp";
import Product2 from "../../Products/Product2.webp";
import Product3 from "../../Products/Product3.webp";
import Product4 from "../../Products/Product4.webp";
import Product5 from "../../Products/Product5.webp";
import Product6 from "../../Products/Product6.webp";
import Product7 from "../../Products/Product7.avif";
import Product8 from "../../Products/Product8.jpg";
import Product9 from "../../Products/Product9.webp";
import Product10 from "../../Products/Product10.webp";
import Product11 from "../../Products/Product11.png";
import Product12 from "../../Products/Product12.webp";
import Product13 from "../../Products/Product13.webp";
import Product14 from "../../Products/Product14.png";
import Product15 from "../../Products/Product15.webp";
import Product16 from "../../Products/Product16.webp";
import Product17 from "../../Products/Product17.webp";
import Product18 from "../../Products/Product18.jpg";
import Product19 from "../../Products/Product19.webp";
import Product20 from "../../Products/Product20.webp";
import Product21 from "../../Products/Product21.jpg";
import Product22 from "../../Products/Product22.jpg";
import Product23 from "../../Products/Product23.jpg";
// import Product24 from "../../Products/Product24.jpg";
import Product25 from "../../Products/Product25.jpeg";
import Product26 from "../../Products/Product26.jpg";
import Product27 from "../../Products/Product27.jpeg";
import Product28 from "../../Products/Product28.webp";
import Product29 from "../../Products/Product29.jpeg";
import Product30 from "../../Products/Product30.webp";
import "./OurProducts.css";


export default function Products() {
  const products = [
    { id: 1, image: Product1 },
    { id: 2, image: Product2 },
    { id: 3, image: Product3 },
    { id: 4, image: Product4 },
    { id: 5, image: Product5 },
    { id: 6, image: Product6 },
    { id: 7, image: Product7 },
    { id: 8, image: Product8 },
    // { id: 9, image: Product9 },
    { id: 10, image: Product10 },
    // { id: 11, image: Product11 },
    { id: 12, image: Product12 },
    { id: 13, image: Product13 },
    // { id: 14, image: Product14 },
    { id: 15, image: Product15 },
    { id: 16, image: Product16 },
    { id: 17, image: Product17 },
    { id: 18, image: Product18 },
    // { id: 19, image: Product19 },
    { id: 20, image: Product20 },
    { id: 21, image: Product21 },
    // { id: 22, image: Product22 },
    { id: 23, image: Product23 },
    { id: 25, image: Product25 },
    { id: 26, image: Product26 },
    // { id: 27, image: Product27 },
    { id: 28, image: Product28},
    { id: 29, image: Product29 },
    // { id: 230, image: Product30 },
  ];

  return (
    <div className="products-section">
      <h2 className="products-title">Our Products</h2>

      <p className="products-subtitle">
        We provide all types of plants — more than <b>500+ plant categories</b> and all types of pots.
      </p>

      <div className="products-grid">
        {products.map((item) => (
          <div className="product-card" key={item.id}>
            <div className="product-image-wrapper">
              <img src={item.image} className="product-image" alt="" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
